import React,{ useState }  from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Redirect,useHistory } from "react-router-dom";
import { setUserLogin } from "reduxs/actions";
import {doPost} from "utils/apiUtil.js"
import {endpoint} from 'utils/constants.js'
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Assignment from '@material-ui/icons/Assignment';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { useStyles } from './styles.js';



export default function ForgotPassword() {
  const classes = useStyles();
  let history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);
  const [submitted, setsubmitted] = useState(false);
  const [state, setstate] = useState({
    niy:""
  });

  const [errors, seterrors] = useState({
    niy:null
  });

  const getDefaultHeader =()=>{
    return {}
  }

  const submit = async()=>{
    let valid = true
    let newErrors = {
      niy:null
    }

    if(state.niy.trim()  === ""){
      valid = false      
      newErrors['niy'] = "niy can not be empty"
    }
    
    
    if(valid){           
      const payload = {
        niy:state.niy
      }
      const response = await doPost(endpoint.forgot_password, payload,"forgot password",getDefaultHeader())
      
      if(response.error){
        for (let key in response.error.errors) {
          newErrors[key] = response.error.errors[key]
        }
      }else{
        setsubmitted(true)            
      }      
    }

    seterrors(newErrors)
      
  }

  const goLogin =(path)=>{
    history.push("/login")
  }

  const handleChange=(fieldName,eventValue)=>{
    let newState = {...state}
    let value = eventValue.target.value

    newState[fieldName] = value
    setstate(newState)
  }

  
  if(submitted){
    return (
      <Container component="main" maxWidth="md">
        <CssBaseline />
        <Grid container justify="center" alignItems="center" style={{height:'100vh'}}>
        <Typography variant="h3"> your request is being processed </Typography>
          <img src='/processed.png' width="300" height="300"/>
          <Grid container justify="center" item xs={12} md={6}>
          <Typography variant="h6"> we will send link to your email </Typography>
          <Typography variant="h5"> please check your email periodically</Typography>            
          </Grid>
          
          <Grid container justify="center" item xs={12} md={4}>
          <Button
            type="button"            
            fullWidth
            variant="contained"
            color="primary"        
            onClick={goLogin}
          >
            Go to Login Page
          </Button>
          </Grid>
          
        </Grid>
        
      </Container>
    )
  }else{
    return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <Assignment />
          </Avatar>
          <Typography component="h1" variant="h5">
            Forgot Password
          </Typography>
          
          <form className={classes.form} noValidate>
            <TextField
              error={errors.niy}
              helperText={errors.niy}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="NIY"
              label="NIY"
              name="NIY"
              value={state.niy}
              onChange={(e)=>handleChange("niy",e)}
            />
            
            
            <Button
              type="button"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={submit}
            >
              Send
            </Button>
            
            <Grid container>            
              <Grid item>
                <Link href="/login" variant="body2">
                  {"Remember your password ? Login"}
                </Link>
              </Grid>
            </Grid>
          </form>
        </div>
        
      </Container>
    );
  }
  
  
  }

